import { render, staticRenderFns } from "./ProductDownloadForm.vue?vue&type=template&id=18f56042&scoped=true"
import script from "./ProductDownloadForm.vue?vue&type=script&lang=js"
export * from "./ProductDownloadForm.vue?vue&type=script&lang=js"
import style0 from "./ProductDownloadForm.vue?vue&type=style&index=0&id=18f56042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f56042",
  null
  
)

export default component.exports